import { GetViewportSize } from "./GetViewportSize";
import { RectSize } from "./RectSize";

export function GetWindowSize(): RectSize
{
    const viewport = GetViewportSize();
    viewport.width *= window.devicePixelRatio;
    viewport.height *= window.devicePixelRatio;
    return viewport;
}